import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IProcessBuyListInput,
  IProcessBuyListResult,
  IShareOrganizationWithBuyListsInput,
  IShareOrganizationWithBuyListsResult,
  IUpdateBuyListNameInput,
  IUpdateBuyListNameResult,
  IUpdateBuyListAliasInput,
  IUpdateBuyListAliasResult,
  IDeleteUserBuyListInput,
  IDeleteUserBuyListResult,
} from '@shared/models/buyers-list';
import { MUTATION_ERROR_FRAGMENT } from '@graphql/errors.fragments';
import { BUY_LIST_FRAGMENT } from '@graphql/queries/buyers-list.queries';

export const PROCESS_BUY_LIST: TypedDocumentNode<
  IProcessBuyListResult,
  IProcessBuyListInput
> = gql`
  mutation processBuyList($input: ProcessBuyListInput!) {
    processBuyList(input: $input)
  }
`;

export const SHARE_ORGANIZATION_WITH_BUY_LISTS: TypedDocumentNode<
  IShareOrganizationWithBuyListsResult,
  IShareOrganizationWithBuyListsInput
> = gql`
  mutation shareOrganizationWithBuyLists(
    $input: ShareOrganizationWithBuyListsInput!
  ) {
    shareOrganizationWithBuyLists(input: $input)
  }
`;

export const UPDATE_BUY_LIST_NAME: TypedDocumentNode<
  IUpdateBuyListNameResult,
  IUpdateBuyListNameInput
> = gql`
  ${BUY_LIST_FRAGMENT}
  ${MUTATION_ERROR_FRAGMENT}
  mutation updateBuyListName($id: ID!, $input: UpdateBuyListNameInput!) {
    updateBuyListName(id: $id, input: $input) {
      result {
        ...BuyListFragment
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;

export const DELETE_USER_BUY_LIST: TypedDocumentNode<
  IDeleteUserBuyListResult,
  IDeleteUserBuyListInput
> = gql`
  mutation deleteUserBuyList($id: ID!) {
    deleteUserBuyList(id: $id) {
      result {
        name
      }
      errors {
        message
      }
    }
  }
`;

export const UPDATE_BUY_LIST_ALIAS: TypedDocumentNode<
  IUpdateBuyListAliasResult,
  IUpdateBuyListAliasInput
> = gql`
  ${MUTATION_ERROR_FRAGMENT}
  mutation updateBuyListAlias($id: ID!, $input: UpdateBuyListAliasInput!) {
    updateBuyListAlias(id: $id, input: $input) {
      result {
        id
        firstName
        surname
        phoneNumber
        email
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;
